import React from "react"
import {Box, Divider, Typography} from "@mui/material";
import PreviewPropertyHighlighter from "../preview/PreviewPropertyHighlighter";

interface Props {
    roofLine?: any,
    propertyName?: string,
    roofLineCharLimit?: number,
    centered?: boolean,
    marginTop?: number | string
    metadataId?: string
}

function CCORoofline(props: Props) {
    if (props.roofLine && props.roofLine.length > 0) {
        return <Box sx={{
            pb: 4, textAlign: props.centered ? 'center' : 'left', lineHeight: '1',
        }}
        >
            <Typography variant={'overline'}>
                <PreviewPropertyHighlighter metadataId={props.metadataId} propertyName={props.propertyName}>
                    {props.roofLineCharLimit ? props.roofLine.substring(0, props.roofLineCharLimit) +
                        (props.roofLine.length > props.roofLineCharLimit ? '...' : '') : props.roofLine}
                </PreviewPropertyHighlighter>
            </Typography>

            <Box sx={{display: "flex", justifyContent: props.centered ? "center" : "start"}}>
                <Divider sx={{width: 115, height: 4, mb: 0, mt: 2, bgcolor: 'primary.main'}}/>
            </Box>
        </Box>
    } else return null
}


export default CCORoofline